import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
export const dispatchViewItemEvent = ({ productName, sku, color, flavor, categories, discount, priceInformation, }) => {
    const itemPrice = priceInformation?.finalPrice?.value || "N/A";
    dispatchTrackingEvent(TrackingEvents.TrackingViewItem, {
        currency: priceInformation?.finalPrice?.currency || "N/A",
        value: itemPrice,
        ecommerce: {
            items: [
                {
                    item_id: sku,
                    currency: priceInformation?.finalPrice?.currency || "N/A",
                    price: itemPrice,
                    discount: String(discount || "N/A"),
                    quantity: "1",
                    index: "0",
                    item_brand: "ploom",
                    item_category: categories?.[0]?.name || "N/A",
                    item_category2: categories?.[1]?.name || "N/A",
                    item_name: productName || "N/A",
                    item_color: String(color || "N/A"),
                    item_flavor: String(flavor || "N/A"),
                    item_strength: "N/A",
                    item_coupon: "N/A",
                    item_coupon_type: "N/A",
                    item_list_id: "N/A",
                    item_list_name: productName || "N/A",
                    item_rewards: "N/A",
                    item_sku: sku,
                    purchase_type: "N/A",
                    carton_format: "N/A",
                    carton_quantity: "N/A",
                },
            ],
        },
    });
};
//# sourceMappingURL=dispatchViewItemEvent.js.map